import React from "react";
import ImageGrid from "../../../components/company_grid";
import Footer from "../../../components/footer";
import AwardHeroSection from "../../About/awards/award_page";
import Awards from "../../About/awards/our_awards";
// import SuccessStory from "../../About/awards/success_story";


function Home() {
  return (
    <div>
      <AwardHeroSection />
      <Awards />
      {/* <SuccessStory /> */}
      <ImageGrid />
      <Footer />
    </div>
  );
}

export default Home;
